module.exports = __webpack_public_path__ + "static/media/bamboo shoot.c8cf008e.jpg";